import { FC } from 'react';
import { createFaqLd } from '@doda/common/src/logics/JobContent/JobTrend/createFaqLd';
import { LABEL_FLAG } from '@doda/common/src/constants/seo/jobTrendConstants';

/**
 * FaqLdのprops
 */
export interface Props {
  targetName: string;
  requirementsShowFlg: boolean;
  incomeShowFlg: boolean;
  workplaceEnvironmentShowFlg: boolean;
  holidayAndWayOfWorkingShowFlg: boolean;
  employmentStatusShowFlg: boolean;
  rankingList;
}

/**
 * FAQ構造化データ作成
 * @param {string} targetName ページの一軸名
 * @returns FAQ構造化データ
 */
export const FaqLd: FC<Props> = ({
  targetName,
  requirementsShowFlg,
  incomeShowFlg,
  workplaceEnvironmentShowFlg,
  holidayAndWayOfWorkingShowFlg,
  employmentStatusShowFlg,
  rankingList,
}) => {
  const list: {
    '@type': string;
    name: string;
    acceptedAnswer: { '@type': string; text: string };
  }[] = [];
  if (requirementsShowFlg) {
    list.push(
      createFaqLd(targetName, rankingList.requirements, LABEL_FLAG.REQUIREMENT)
    );
  }
  if (incomeShowFlg) {
    list.push(createFaqLd(targetName, rankingList.income, LABEL_FLAG.INCOME));
  }
  if (workplaceEnvironmentShowFlg) {
    list.push(
      createFaqLd(
        targetName,
        rankingList.workplaceEnvironment,
        LABEL_FLAG.WORKPLACE_ENVIRONMENT
      )
    );
  }
  if (holidayAndWayOfWorkingShowFlg) {
    list.push(
      createFaqLd(
        targetName,
        rankingList.holidayAndWayOfWorking,
        LABEL_FLAG.HOLIDAY_AND_WAY_OF_WORKING
      )
    );
  }
  if (employmentStatusShowFlg) {
    list.push(
      createFaqLd(
        targetName,
        rankingList.employmentStatus,
        LABEL_FLAG.EMPLOYMMENT_STATUS
      )
    );
  }

  const jsonData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: list,
  };

  return (
    <>
      {jsonData ? (
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonData),
          }}
        />
      ) : null}
    </>
  );
};

FaqLd.displayName = 'FaqLd';
